// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_pv-5";
export var filledCircle = "_pv-4";
export var historyEntry = "_pv-3";
export var messageSideLeft = "_pv-1";
export var messageSideRight = "_pv-2";
export var orderTrackingCarouselWrapper = "_pv-6";
export var orderTrackingInfoContainer = "_pv-0";